import { render, staticRenderFns } from "./package-other-edit-tab.vue?vue&type=template&id=3a35426c&scoped=true"
import script from "./package-other-edit-tab.vue?vue&type=script&lang=js"
export * from "./package-other-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./package-other-edit-tab.vue?vue&type=style&index=0&id=3a35426c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a35426c",
  null
  
)

export default component.exports